import { Component, OnInit, Renderer2 } from '@angular/core'
import { Router } from '@angular/router'
import { GenericResponse } from 'src/app/shared/class/core/generic-response/generic-response'
import { HttpclientService } from 'src/app/shared/service/httpclient/httpclient.service'
import { NavigationService } from 'src/app/shared/service/navigation/navigation.service'
import { SubSink } from 'subsink'
import { LeftNavItem } from './navigation.model'
import { Location } from '@angular/common'
import { UserService } from 'src/app/shared/service/user/user.service'
import { DashboardService } from 'src/app/shared/service/dashhboard/dashboard.service'
import { BehaviorSubject } from 'rxjs'

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements OnInit {
  private subs = new SubSink();

  leftNavItems = null
  genericResponse: GenericResponse
  responseReceived: Promise<boolean>
  classToggled: any;
  componentHeirarchyLevel: number;
  isExpandedAll: boolean = false;

  constructor(
    private httpClientService: HttpclientService,
    private router: Router,
    private navigationService: NavigationService,
    private _userService: UserService,
    private location: Location,
    private dashboardService: DashboardService,
    private readonly renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.getMenuElements()
  }

  private getMenuElements() {
    let productId = this.getProductId() || 9;
    let componentId = parseInt(sessionStorage.getItem("componentId"));
    let parentRoute = this.location.path().split('/')[1] !== "user" ? "um" : "user"
    this.componentHeirarchyLevel = this.navigationService.getComponentHeirarchyLevel(parentRoute);
    let lobId = 0
    let newClaimant = 0
    if (parentRoute === "claim") {
      lobId = parseInt(sessionStorage.getItem('lobId'))
      newClaimant = parseInt(sessionStorage.getItem('newClaimant'))
    }
    let componentEntityName = this.navigationService.getComponentEntity(parentRoute)
    const entityId = componentEntityName ? parseInt(sessionStorage.getItem(componentEntityName)) : 0
    const data = {
      userId: "",
      productId: productId,
      lobId: lobId,
      newClaimant: newClaimant,
      entityId: entityId,
      componentHierarchyLevelId: this.componentHeirarchyLevel
    }
    this.subs.sink = this.httpClientService
      .post('getmenuenewlements', JSON.stringify(data))
      .subscribe(
        (data) => {
          console.log(data);
          data.leftNavItems.map(item => {
            item.componentUrl = item.componentUrl.replaceAll("user/", "");
          })
          // let commSecurity = JSON.parse(JSON.stringify(data.leftNavItems[0]));
          // commSecurity.componentName = "Communication Security";
          // commSecurity.componentUrl = "communication-security";

          if (parseInt(sessionStorage.getItem("ENTITY_TYPE_ID")) === 2) {
            let index = data.leftNavItems.findIndex(x => x.componentName === "User Details");
            data.leftNavItems.splice(index, 1);
          }
          if (parseInt(sessionStorage.getItem("ENTITY_TYPE_ID")) === 2) {
            let index = data.leftNavItems.findIndex(x => x.componentName === "Template Security");
            data.leftNavItems.splice(index, 1);
          }
          // data.leftNavItems.unshift(commSecurity);
          // console.log("Communication Security Menu Item");
          // console.log(data.leftNavItems);
          this.genericResponse = new GenericResponse(data)
          this.leftNavItems = this.genericResponse.payload;
          const activeComponent: LeftNavItem = this.leftNavItems
            .flatMap(_ => [_, ..._.children])
            .find(this.findItemByUrl);
          if (!activeComponent || this.leftNavItems.length == 0) {
            this.navigateToNoAccess();
            this.responseReceived = Promise.resolve(true)
            return;
          }
          this.submenuitemClicked(activeComponent);
          this.responseReceived = Promise.resolve(true);
        },
        (error) => {
          console.log(error)
        }
      )
  }

  findItemByUrl = (leftNavItem: LeftNavItem): boolean => {
    const activeRoute: string = this.location.path()?.split('/').pop() || "my-claims";
    if (leftNavItem.componentUrl == activeRoute) {
      return true;
    }
  }

  navigateToNoAccess() {
    const route = this.location.path().split('/');
    const module = route[route.length - 2];
    this.router.navigate([(module ? module : 'home') + "/no-screen-access"]);
  }

  isMenuChildActive(menuitem): boolean {
    const activeRouteComponentId = sessionStorage.getItem('SEL_COMP_ID')
    if (!menuitem.children.length) return activeRouteComponentId == menuitem.componentID
    return menuitem.children.some((_) => activeRouteComponentId == _.componentID)
  }

  isSubMenuChildActive(submenuitem): boolean {
    return submenuitem.componentID == sessionStorage.getItem('SEL_COMP_ID');
  }

  toggleField() {
    this.isExpandedAll = false;
    this.collapseExpandAll();
    this.classToggled = !this.classToggled
    if (this.classToggled) {
      this.leftNavItems.forEach((item, i) => {
        const parent = document.getElementById(`parentMenu${i}`);
        const children = document.getElementById(`collapse${i}`);
        if (parent) {
          this.renderer.addClass(parent, "collapsed");
          this.renderer.removeClass(children, "show");
        }
      })
    }
  }

  collapseExpandAll() {
    if (!this.classToggled) {
      this.isExpandedAll = !this.isExpandedAll;
      if (this.isExpandedAll) {
        this.leftNavItems.forEach((item, i) => {
          const parent = document.getElementById(`parentMenu${i}`);
          const children = document.getElementById(`collapse${i}`);
          if (parent) {
            this.renderer.removeClass(parent, "collapsed");
            this.renderer.addClass(parent, "collapse");
            this.renderer.addClass(children, "show");
          }
        })
      } else {
        this.leftNavItems.forEach((item, i) => {
          const parent = document.getElementById(`parentMenu${i}`);
          const children = document.getElementById(`collapse${i}`);
          if (parent && item.componentName !== 'Claimants') {
            this.renderer.addClass(parent, "collapsed");
            this.renderer.removeClass(children, "show");
          }
        })
      }
    }
  }

  isNavigateInNewTab(menuitem): boolean {
    return menuitem.componentUrl?.split('/')?.length === 3
  }

  navigateInNewTab(menuitem) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([menuitem.componentUrl])
    )
    window.open(url, '_blank')
  }

  itemDragged(e) {
    console.log(e)
  }

  menuItemClicked(menuItem) {
    sessionStorage.setItem("componentId", menuItem.componentID)
    sessionStorage.setItem("componentDesc", menuItem.componentDesc)
    sessionStorage.setItem("SEL_COMP_ID", menuItem.componentID);
  }

  submenuitemClicked(submenuitem) {
    const { componentID, componentDesc, componentType, componentUrl } = submenuitem;
    sessionStorage.setItem("componentId", componentID)
    sessionStorage.setItem("componentDesc", componentDesc)
    sessionStorage.setItem("SEL_COMP_ID", componentID);
    if (componentType?.toLowerCase() == 'dashboard') {
      if (this.dashboardService.componentId$) {
        this.dashboardService.componentId$.next(componentID);
      } else {
        this.dashboardService.componentId$ = new BehaviorSubject(componentID);
      }
    }
    if ((sessionStorage.getItem("defaultRoute")) && (sessionStorage.getItem("defaultRoute")?.toLowerCase() == componentUrl?.toLowerCase())) {

      sessionStorage.setItem("dcomponentId", componentID)
      sessionStorage.setItem("dcomponentDesc", componentDesc)
    }
  }

  getDataParentForMenuItem(itemName: string): string {
    // Data parent controls accordion expansion
    // Claimants need to be treated like seperate menu so no data-parent provided
    if (itemName !== "Claimants") {
      return "#accordionSidebar"
    }
    return ""
  }

  getProductId(): number {
    let productAccess = this._userService.getProductAccess();

    let paccess = JSON.parse(productAccess.toString()).find((item) => item.productName === "KlearUserSecurity");

    const productId = paccess?.productID || "9";

    return parseInt(productId);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
}